import { DeleteSharp, EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import {
  deleteCancelMemberSubject,
  getCancelMemberSubject,
  insertCancelMemberSubject,
  updateCancelMemberSubject
} from "src/api/commonapi";
import CustomLoader from "src/components/CustomLoader";

export default function CancelMembershipSubject() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cancelMembershipSubjectData, setcancelMembershipSubjectData] = useState({
    subject: ""
  });
  const [tableData, setTableData] = useState([]);
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const resetFormData = () => {
    setcancelMembershipSubjectData({
      subject: ""
    });
  };
  const [isLoading, setIsLoading] = useState(false);

  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);

  const handleSubmit = async (newData = undefined) => {
    if (newData != undefined ? newData : cancelMembershipSubjectData.c_m_s_id != undefined) {
      // update
      if ((newData != undefined ? newData : cancelMembershipSubjectData).subject != "") {
        let fnData = new FormData();
        fnData.append(
          "c_m_s_id",
          newData != undefined ? newData.c_m_s_id : cancelMembershipSubjectData.c_m_s_id
        );
        fnData.append(
          "subject",
          newData != undefined ? newData.subject : cancelMembershipSubjectData.subject
        );
        setLoading(true);
        setIsLoading(true);
        let resp = await updateCancelMemberSubject(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          newData == undefined && toggleAddEditModal();
          getMeetingFeedbackForData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    } else {
      // Insert
      if (cancelMembershipSubjectData.subject != "") {
        let fnData = new FormData();
        fnData.append("subject", cancelMembershipSubjectData.subject);
        setLoading(true);
        setIsLoading(true);
        let resp = await insertCancelMemberSubject(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          getMeetingFeedbackForData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
        setLoading(false);
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    }
  };
  const deleteMemberDeactivateReasons = async (c_m_s_id) => {
    const resp = await deleteCancelMemberSubject(c_m_s_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };
  const getMeetingFeedbackForData = async () => {
    setIsLoading(true);
    let res = await getCancelMemberSubject();
    setIsLoading(false);
    setTableData(res);
  };
  useEffect(() => {
    getMeetingFeedbackForData();
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.subject,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          {row.is_deleted == 0 && (
            <>
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    setcancelMembershipSubjectData({
                      subject: row.subject,
                      c_m_s_id: row.c_m_s_id
                    });
                    toggleAddEditModal();
                  }}
                >
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    setDvisible({ mval: true, id: row.c_m_s_id });
                  }}
                >
                  <DeleteSharp color="error" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal
        visible={dvisible}
        setVisible={setDvisible}
        deletefunc={deleteMemberDeactivateReasons}
      />

      <Page title="LVB Cancel Membership Subject | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Cancel Membership Subject
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (toggleAddEditModal(), resetFormData())}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add Cancel Membership Subject
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Add Cancel Membership Subject
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Cancel Membership Subject"
                      name="subject"
                      placeholder="Enter Cancel Membership Subject"
                      onChange={(e) => {
                        setcancelMembershipSubjectData({
                          ...cancelMembershipSubjectData,
                          subject: e.target.value
                        });
                      }}
                      value={cancelMembershipSubjectData?.subject}
                    />
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleSubmit()}
                      // disabled={loading}
                      disabled={isLoading || loading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
